import type { ReactNode } from 'react';
import clsx from 'clsx';

export interface CollapsibleRegionProps {
    id: string;
    isOpen: boolean;
    children: ReactNode;
}

export function CollapsibleRegion({ id, isOpen, children }: CollapsibleRegionProps) {
    return (
        <div
            id={id}
            aria-hidden={!isOpen}
            inert={!isOpen || undefined}
            className={clsx(
                'grid transition-[grid-template-rows] duration-200 ease-out motion-reduce:transition-none',
                isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
            )}
        >
            <div className="min-h-0 overflow-hidden">{children}</div>
        </div>
    );
}

export default CollapsibleRegion;
